module.exports = __webpack_public_path__ + "img/5@2x.e89088b6.png";